// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Xb7DpQ","customInput":"xLXDx1","fakeInput":"stsNXN","greaterThanZero":"_4HJPTV"};